module.exports = __webpack_public_path__ + "img/1557614097893236737.dcd06d2b.png";